import { BaseClickSchema } from '@space-core/datahub/hotmartClub'
import { UserInfoRole } from '@space-shell/common/services/user'

export default class ClickPwaBannerDownloadSchema extends BaseClickSchema {
  action: string
  role: string

  constructor() {
    super({
      componentName: 'PWA'
    })
    this.action = 'click_pwa_banner_download'
    this.role = UserInfoRole.VIEWER
  }

  getDataHubEventData() {
    return {
      ...super.prepare(),
      pushKind: 'NOT_PUSH_EVENT',
      userRole: this.role
    }
  }
}
